import { useEffect } from "react";
import { useOutletContext } from "react-router";
import MetadataDetail from "./MetadataDetail";
import MetadataDetailEdit from "./MetadataDetailEdit";

const Metadata = () => {
  const {
    setBreadcrumbs,
    templateInfo,
    isEditing,
    isNew,
    formHeaders,
    editedFormHeaders,
    setEditedFormHeaders,
    translate,
  } = useOutletContext();

  useEffect(() => {
    if (templateInfo) {
      setBreadcrumbs([
        {
          id: 0,
          title: "page_titles.form-templates",
          route: "auth.formTemplates",
        },
        { id: 1, customTitle: templateInfo?.name || "" },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateInfo]);

  return (
    <>
      {isEditing || isNew ? (
        <MetadataDetailEdit
          formHeaders={editedFormHeaders}
          setFormHeaders={setEditedFormHeaders}
          isNew={isNew}
        />
      ) : (
        <MetadataDetail formHeaders={formHeaders} translate={translate} />
      )}
    </>
  );
};
export default Metadata;
